import { render, staticRenderFns } from "./ContactPageForm.vue?vue&type=template&id=6a0afe7b&lang=pug"
import script from "./ContactPageForm.vue?vue&type=script&lang=js"
export * from "./ContactPageForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports